import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../api/axiosConfig";
import { Spinner, Card } from "react-bootstrap";
import PedidoDetalle from "./PedidoDetalle";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function PedidoDetallePag() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [pedido, setPedido] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const cargar = async () => {
      try {
        const res = await axios.get(`/pedidos/${id}`);
        setPedido(res.data);
      } catch (e) {
        console.error(e);
        toast.error("No se pudo cargar el pedido");
      } finally {
        setCargando(false);
      }
    };
    cargar();
  }, [id]);

  if (cargando) {
    return (
      <div className="container mt-4 d-flex justify-content-center">
        <Spinner animation="border" />
      </div>
    );
  }

  if (!pedido) {
    return (
      <div className="container mt-4">
        <ToastContainer position="top-right" autoClose={3000} />
        <Card className="p-4 text-center">Pedido no encontrado</Card>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <ToastContainer position="top-right" autoClose={3000} />
      <PedidoDetalle pedido={pedido} onClose={() => navigate(-1)} />
    </div>
  );
}
